<template>
  <ul class="flex items-center gap-2 2xl:gap-3 select-none">
    <!-- Her bir sosyal medya platformu için ikon ve bağlantı -->
    <li v-for="(item, key) in share" :key="`share-${item.title}-${key}`">
      <client-only>
        <a
          :href="`${item.link}${locationHref}`"
          :aria-label="item.title"
          target="_blank"
          rel="noopener noreferrer"
          class="h-6 w-6 flex items-center justify-center"
        >
          <AtomsSvg
            :icon="item.svg"
            class="text-brand-first duration-300 hover:text-brand-second text-xl"
          />
        </a>
      </client-only>
    </li>

    <!-- Web Share API kullanan "Diğer" paylaşım butonu -->
    <li
      class="group flex items-center relative cursor-pointer text-brand-first"
      @click="shareNavigator()"
      role="button"
      tabindex="0"
      :aria-label="$t('Other')"
      @keydown.enter.prevent="shareNavigator()"
      @keydown.space.prevent="shareNavigator()"
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        class="duration-300 group-hover:text-brand-second"
      >
        <path
          fill="currentColor"
          d="M12 7a2 2 0 1 0-2-2a2 2 0 0 0 2 2m0 10a2 2 0 1 0 2 2a2 2 0 0 0-2-2m0-7a2 2 0 1 0 2 2a2 2 0 0 0-2-2"
        ></path>
      </svg>
      <span class="font-medium group-hover:text-brand-second duration-300">{{
        $t("Other")
      }}</span>
    </li>
  </ul>
</template>

<script setup>
// Props tanımı: Paylaşım yapılacak başlık
const props = defineProps({
  title: { type: String },
});

// Paylaşım yapılabilecek sosyal medya platformları listesi
const share = ref([
  {
    title: "Facebook",
    link: "https://www.facebook.com/sharer/sharer.php?u=",
    icon: "facebook-f",
    svg: '<path fill="currentColor" d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4z"/>',
  },
  {
    title: "Twitter",
    link: "https://twitter.com/intent/tweet?url=",
    icon: "x-twitter",
    svg: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m3 21l7.548-7.548M21 3l-7.548 7.548m0 0L8 3H3l7.548 10.452m2.904-2.904L21 21h-5l-5.452-7.548" color="currentColor"/>',
  },
  {
    title: "Linkedin",
    link: "https://www.linkedin.com/shareArticle?mini=true&url=",
    icon: "linkedin",
    svg: '<path fill="currentColor" d="M20.47 2H3.53a1.45 1.45 0 0 0-1.47 1.43v17.14A1.45 1.45 0 0 0 3.53 22h16.94a1.45 1.45 0 0 0 1.47-1.43V3.43A1.45 1.45 0 0 0 20.47 2M8.09 18.74h-3v-9h3ZM6.59 8.48a1.56 1.56 0 1 1 0-3.12a1.57 1.57 0 1 1 0 3.12m12.32 10.26h-3v-4.83c0-1.21-.43-2-1.52-2A1.65 1.65 0 0 0 12.85 13a2 2 0 0 0-.1.73v5h-3v-9h3V11a3 3 0 0 1 2.71-1.5c2 0 3.45 1.29 3.45 4.06Z"/>',
  },
  {
    title: "Whatsapp",
    link: "https://wa.me/?text=",
    icon: "whatsapp",
    svg: '<path fill="currentColor" d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.23 8.23 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23c-1.48 0-2.93-.39-4.19-1.15l-.3-.17l-3.12.82l.83-3.04l-.2-.32a8.2 8.2 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31c-.22.25-.87.86-.87 2.07c0 1.22.89 2.39 1 2.56c.14.17 1.76 2.67 4.25 3.73c.59.27 1.05.42 1.41.53c.59.19 1.13.16 1.56.1c.48-.07 1.46-.6 1.67-1.18s.21-1.07.15-1.18c-.07-.1-.23-.16-.48-.27c-.25-.14-1.47-.74-1.69-.82c-.23-.08-.37-.12-.56.12c-.16.25-.64.81-.78.97c-.15.17-.29.19-.53.07c-.26-.13-1.06-.39-2-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.12-.24-.01-.39.11-.5c.11-.11.27-.29.37-.44c.13-.14.17-.25.25-.41c.08-.17.04-.31-.02-.43c-.06-.11-.56-1.35-.77-1.84c-.2-.48-.4-.42-.56-.43c-.14 0-.3-.01-.47-.01"/>',
  },
]);

// Bulunulan sayfanın tam URL'si
const locationHref = ref("");

// window nesnesine erişim SSR'den korunmak için onMounted içinde yapılır
onMounted(() => {
  locationHref.value = window?.location?.href || "";
});

// Web Share API kullanarak yerel paylaşım yapılmasını sağlayan fonksiyon
const shareNavigator = () => {
  if (navigator?.share) {
    navigator
      .share({
        title: props.title,
        text: props.title,
        url: locationHref.value,
      })
      .catch((error) => console.error("Paylaşım başarısız:", error));
  }
};
</script>
